import './ticket_summary_text_view.js.coffee';# Added by Script 
Namespace 'Customer.Dashboard'

class Customer.Dashboard.TicketSummaryValuesTextView extends Customer.Dashboard.TicketSummaryTextView
  _text: ->
    ("#{key}: #{value}" for key, value of @ticketSummary.get('values')).join(', ')
